module.exports = __webpack_public_path__ + "static/media/eye.abea43b7.svg";